<template>
  <div class="order-chart relative">
    <v-chart v-if="ohlc.length > 0" autoresize :option="data_chart" @click="activeModal"></v-chart>
    <p class="pl-0 font-semibold text-ontick-yellow-900 dark:text-ontick-yellow-600 md:pl-20">
      Gráfico referente apenas ao dia: {{ period.end | moment("L") }}
    </p>
    <portal to="modal">
      <modal-order
        v-if="active_modal"
        :active="active_modal"
        :params_id="params_id"
        @closeModal="active_modal = false"
      />
    </portal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import VChart from "vue-echarts";
import { use, graphic, init } from "echarts/core";
import { CanvasRenderer, SVGRenderer } from "echarts/renderers";
import { CandlestickChart, BarChart } from "echarts/charts";
import {
  GridComponent,
  DatasetComponent,
  DataZoomComponent,
  BrushComponent,
  VisualMapComponent,
  TooltipComponent,
  MarkLineComponent,
  MarkPointComponent,
} from "echarts/components";

use([
  CanvasRenderer,
  SVGRenderer,
  CandlestickChart,
  BarChart,
  GridComponent,
  DatasetComponent,
  VisualMapComponent,
  DataZoomComponent,
  BrushComponent,
  TooltipComponent,
  MarkLineComponent,
  MarkPointComponent,
]);
export default {
  components: {
    VChart,
    modalOrder: () => import("../order/modal.component.vue"),
  },
  data() {
    return {
      data_chart: {},
      params_id: {},
      active_modal: false,
      ohlc: [],
    };
  },

  props: {
    period: { type: Object, default: {} },
  },

  created() {
    this.getChart(this.period);
  },

  computed: {
    ...mapState({
      config: (state) => state.config,
      user_code: (state) => state.config.user_code,
    }),
  },

  watch: {
    period: {
      deep: true,
      handler(val) {
        this.getChart(val);
        return val;
      },
    },
  },

  methods: {
    getChart(period) {
      this.$api
        .get(
          `${this.$endpoint.PERFORMANCE_CHART}/${period.investment_id}?start_date=${period.end}&end_date=${period.end}`
        )
        .then((response) => {
          this.ohlc = response.data.ohlc;

          this.chart(response.data);
        })
        .catch((error) => {});
    },

    activeModal(val) {
      if (val.componentType == "markPoint") {
        this.active_modal = true;
        this.params_id = {
          order_id: val.data.order_id,
          investment_id: this.period.investment_id,
        };
      }
    },

    formatDate(date) {
      // return `${date.slice(6, 8)}/${date.slice(4, 6)}/${date.slice(
      //   0,
      //   4
      // )} ${date.slice(8, 10)}:${date.slice(10, 12)}`;

      return `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(
        6,
        8
      )}T${date.slice(8, 10)}:${date.slice(10, 12)}:00-03:00`;
    },

    tooltipChart(type) {
      let tooltip = {};

      if (type == "entry") {
        tooltip = {
          show: true,
          trigger: "item",
          formatter: function (param) {
            let render = `<div class="w-full">
                                  <div class="flex  items-center space-x-2">
                                    <div style="background-color:${param.color}" class="w-3 h-3  rounded-full"></div>
                                    <div class="flex">Tipo: <p class="font-semibold mx-2">${param.data.type}</p></div>
                                 </div>
                                 <div class="flex  items-center space-x-2">
                                    <div style="background-color:${param.color}" class="w-3 h-3  rounded-full"></div>
                                    <div class="flex">Preço: <p class="font-semibold mx-2">${param.data.value}</p></div>
                                  </div>
                                  <div class="flex  items-center space-x-2">
                                    <div style="background-color:${param.color}" class="w-3 h-3  rounded-full"></div>
                                    <div class="flex">Volume: <p class="font-semibold mx-2">${param.data.volume}</p></div>
                                  </div>
                                  <div class="flex  items-center space-x-2">
                                    <div style="background-color:${param.color}" class="w-3 h-3  rounded-full"></div>
                                    <div class="flex">Comentario: <p class="font-semibold mx-2">${param.data.comment}</p></div>
                                  </div>
                                   <div class="flex  items-center space-x-2">
                                    <div style="background-color:${param.color}" class="w-3 h-3  rounded-full"></div>
                                    <div class="flex">Data: <p class="font-semibold mx-2">${param.data.xAxis}</p></div>
                                  </div>
                               </div>`;
            return render;
          },
        };
      } else {
        tooltip = {
          show: true,
          trigger: "item",
          formatter: function (param) {
            let render = `<div class="w-full">
                                  <div class="flex  items-center space-x-2">
                                    <div style="background-color:${param.color}" class="w-3 h-3 rounded-full"></div>
                                    <div class="flex">Volume: <p class="font-semibold mx-2">${
                                      param.data.volume
                                    }</p></div>
                                  </div>
                                  <div class="flex  items-center space-x-2">
                                    <div style="background-color:${param.color}" class="w-3 h-3 rounded-full"></div>
                                    <div class="flex">Resultado: <p class="font-semibold mx-2">R$ ${param.data.result.toFixed(
                                      2
                                    )}</p></div>
                                  </div>
                                   <div class="flex  items-center space-x-2">
                                    <div style="background-color:${param.color}" class="w-3 h-3 rounded-full"></div>
                                    <div class="flex">Data: <p class="font-semibold mx-2">${param.data.xAxis}</p></div>
                                  </div>
                               </div>`;
            return render;
          },
        };
      }
      return tooltip;
    },

    positionsList(positions, params) {
      let line = [];
      let point = [];
      let dark = this.config.ui_theme == "DARK" ? this.config.theme_chart.dark : this.config.theme_chart.light;

      positions.forEach((item) => {
        let create_line = [];
        if (item.hasOwnProperty("entry")) {
          create_line.push({
            name: item.entry.type,
            symbol: "circle",
            symbolSize: 10,
            label: {
              show: false,
            },
            emphasis: {
              label: {
                show: true,
              },
            },
            lineStyle: {
              width: 2,
              color: item.result > 0 ? "#17c177" : item.result == 0 ? dark.font_color : "#dd5b5b",
            },
            yAxis: item.entry.price,
            xAxis: this.moment(item.entry.time).format("DD/MM/YYYY kk:mm"),
            result: item.result,
            tooltip: {
              show: true,
              trigger: "item",
              formatter: function (param) {
                return `<div class="flex space-x-2"> <div> Resultado: </div> <p class="font-semibold">R$ ${param.data.result.toFixed(
                  2
                )}</p></div>`;
              },
            },
          });
          point.push({
            symbol: "circle",
            symbolSize: 11,
            label: { show: false },
            // name: item.strategy_name,
            value: item.entry.price,
            xAxis: this.moment(item.entry.time).format("DD/MM/YYYY kk:mm"),
            yAxis: item.entry.price,
            order_id: item.entry.order_id,
            investment_id: params.investment_id,
            type: item.entry.type,
            comment: item.entry.comment,
            volume: item.volume,
            result: item.result,
            itemStyle: {
              color: item.result > 0 ? "#17c177" : item.result == 0 ? dark.font_color : "#dd5b5b",
            },
            tooltip: this.tooltipChart("entry"),
          });
        }
        if (item.hasOwnProperty("exit")) {
          create_line.push({
            name: item.exit.type,
            symbol: "circle",
            symbolSize: 11,
            label: {
              show: false,
            },
            emphasis: {
              label: {
                show: false,
              },
            },
            lineStyle: {
              width: 2,
              color: item.result > 0 ? "#17c177" : item.result == 0 ? dark.font_color : "#dd5b5b",
            },
            result: item.result,
            xAxis: this.moment(item.exit.time).format("DD/MM/YYYY kk:mm"),
            yAxis: item.exit.price,
          });
          point.push({
            symbol: "circle",
            symbolSize: 10,
            label: { show: false },
            // name: item.strategy_name,
            value: item.exit.price,
            xAxis: this.moment(item.exit.time).format("DD/MM/YYYY kk:mm"),
            yAxis: item.exit.price,
            order_id: item.exit.order_id,
            investment_id: params.investment_id,
            volume: item.volume,
            result: item.result,
            itemStyle: {
              color: item.result > 0 ? "#17c177" : item.result == 0 ? dark.font_color : "#dd5b5b",
            },
            tooltip: this.tooltipChart("exit"),
          });
        }
        line.push(create_line);
      });

      return { line, point };
    },

    chart({ ohlc, orders, params, positions }) {
      let dark = this.config.ui_theme == "DARK" ? this.config.theme_chart.dark : this.config.theme_chart.light;

      const upColor = "#0694e6";
      const upBorderColor = this.config.ui_theme == "DARK" ? "#51bfff" : "#046299";
      const downColor = "#6c737f";
      const downBorderColor = this.config.ui_theme == "DARK" ? "#abafb6" : "#2D3748";

      let new_ohcl = [];
      let date = [];
      let volume = [];
      let { line, point } = this.positionsList(positions, params);
      let grid = this.$screen.portrait ? "10%" : "5%";

      line.push(
        {
          name: "limit time",
          valueDim: "close",
          label: {
            show: true,
            formatter(val) {
              // console.log(val);
              return val.value.split(" ")[1];
            },
            color: dark.font_color,
          },

          valueIndex: 0,
          lineStyle: { color: "#D7C94E" },
          xAxis: this.moment(params.limit_time).add(3, "hours").format("DD/MM/YYYY kk:mm") || "",
          tooltip: {
            show: true,
            trigger: "item",
            formatter: function () {
              return "Hora limite";
            },
          },
        },
        {
          name: "start time",
          label: {
            show: true,
            formatter(val) {
              return val.value.split(" ")[1];
            },
            color: dark.font_color,
          },

          valueDim: "close",
          valueIndex: 0,
          lineStyle: { color: "#13a163" },
          xAxis: this.moment(params.start_time).add(3, "hours").format("DD/MM/YYYY kk:mm") || "",
          tooltip: {
            show: true,
            trigger: "item",
            formatter: function () {
              return "Hora de inicio";
            },
          },
        },
        {
          name: "end time",
          label: {
            show: true,
            formatter(val) {
              return val.value.split(" ")[1];
            },
            color: dark.font_color,
          },

          valueDim: "close",
          valueIndex: 0,
          lineStyle: { color: "#b84c4c" },
          xAxis: this.moment(params.end_time).add(3, "hours").format("DD/MM/YYYY kk:mm") || "",
          tooltip: {
            show: true,
            trigger: "item",
            formatter: function () {
              return "Hora final";
            },
          },
        }
      );
      ohlc.forEach((item) => {
        new_ohcl.push([item.o, item.c, item.l, item.h]);
        volume.push(item.v);
        date.push(this.moment(this.formatDate(item.dt)).format("DD/MM/YYYY kk:mm"));
      });

      let option = {
        // dataset: {
        //   source: ohlc,
        //   dimensions: ["c", "h", "l", "o", "t", "v", "dt"],
        // },
        // legend: {
        //   bottom: 10,
        //   left: "center",
        //   //   data: ["Dow-Jones index", "MA5", "MA10", "MA20", "MA30"],
        // },

        axisPointer: {
          link: [
            {
              xAxisIndex: "all",
            },
          ],
          label: {
            backgroundColor: dark.line,
          },
        },

        tooltip: {
          trigger: "axis",
          formatter: (param) => {
            let render;
            if (param[0].seriesType == "candlestick") {
              render = `<div class="w-full">
                                  <div class="flex  items-center space-x-2">
                                    <div style="background-color:${param[0].color}" class="w-3 h-3 rounded-full"></div>
                                    <div class="flex">Data: <p class="font-semibold mx-2">${param[0].name}</p></div>
                                 </div>
                                 <div class="flex  items-center space-x-2">
                                    <div style="background-color:${param[0].color}" class="w-3 h-3 rounded-full"></div>
                                    <div class="flex">Abertura: <p class="font-semibold mx-2">${param[0].data[1]}</p></div>
                                  </div> 
                                   <div class="flex  items-center space-x-2">
                                    <div style="background-color:${param[0].color}" class="w-3 h-3 rounded-full"></div>
                                    <div class="flex">Máxima: <p class="font-semibold mx-2">${param[0].data[4]}</p></div>
                                  </div>
                                  <div class="flex  items-center space-x-2">
                                    <div style="background-color:${param[0].color}" class="w-3 h-3 rounded-full"></div>
                                    <div class="flex">Mínima: <p class="font-semibold mx-2">${param[0].data[3]}</p></div>
                                  </div>
                                  
                                   <div class="flex  items-center space-x-2">
                                    <div style="background-color:${param[0].color}" class="w-3 h-3 rounded-full"></div>
                                    <div class="flex">Fechamento: <p class="font-semibold mx-2">${param[0].data[2]}</p></div>
                                  </div>
                                     <div class="flex  items-center space-x-2">
                                    <div class="w-3 h-3 bg-ontick-blue-700 rounded-full"></div>
                                    <div class="flex">Volume: <p class="font-semibold mx-2">${param[1].data}</p></div>
                                  </div>
                               </div>`;
            } else {
              render = `<div class="w-full">
                                  <div class="flex  items-center space-x-2">
                                    <div style="background-color:${param[0].color}" class="w-3 h-3 rounded-full"></div>
                                    <div class="flex">Data: <p class="font-semibold mx-2">${param[0].name}</p></div>
                                 </div>
                                 <div class="flex  items-center space-x-2">
                                    <div style="background-color:${param[0].color}" class="w-3 h-3 rounded-full"></div>
                                    <div class="flex">Abertura: <p class="font-semibold mx-2">${param[1].data[1]}</p></div>
                                  </div> 
                                   <div class="flex  items-center space-x-2">
                                    <div style="background-color:${param[0].color}" class="w-3 h-3 rounded-full"></div>
                                    <div class="flex">Máxima: <p class="font-semibold mx-2">${param[1].data[4]}</p></div>
                                  </div>
                                  <div class="flex  items-center space-x-2">
                                    <div style="background-color:${param[0].color}" class="w-3 h-3 rounded-full"></div>
                                    <div class="flex">Mínima: <p class="font-semibold mx-2">${param[1].data[3]}</p></div>
                                  </div>
                                  
                                   <div class="flex  items-center space-x-2">
                                    <div style="background-color:${param[0].color}" class="w-3 h-3 rounded-full"></div>
                                    <div class="flex">Fechamento: <p class="font-semibold mx-2">${param[1].data[2]}</p></div>
                                  </div>
                                     <div class="flex  items-center space-x-2">
                                    <div class="w-3 h-3 bg-ontick-blue-700 rounded-full"></div>
                                    <div class="flex">Volume: <p class="font-semibold mx-2">${param[0].data}</p></div>
                                  </div>
                               </div>`;
            }

            return render;
          },
          axisPointer: {
            type: "line",
          },
        },

        grid: [
          {
            left: grid,
            right: "5%",
            height: "70%",
          },
          {
            left: grid,
            right: "5%",
            top: "83%",
            height: "16%",
          },
        ],
        xAxis: [
          {
            type: "category",
            data: date,
            inverse: true,
            scale: true,
            boundaryGap: false,
            axisLine: { onZero: false },
            splitLine: { show: false },
            min: "dataMin",
            max: "dataMax",
            axisPointer: {
              z: 100,
            },

            axisLabel: {
              color: dark.font_color,
              fontSize: 10,
              fontFamily: "Poppins",
              // formatter: function (value) {
              //   value = value.toLocaleString("pt-BR", {
              //     minimumFractionDigits: 0,
              //   });
              //   return value;
              // },
            },

            axisLine: {
              lineStyle: { color: dark.line },
            },
          },
          {
            type: "category",
            inverse: true,
            gridIndex: 1,
            data: date,
            scale: true,
            boundaryGap: false,
            axisLine: { onZero: false },
            axisTick: { show: false },
            splitLine: { show: false },
            axisLabel: { show: false },
            min: "dataMin",
            max: "dataMax",
          },
        ],
        yAxis: [
          {
            scale: true,
            splitArea: {
              show: false,
            },
            splitLine: {
              lineStyle: {
                color: "#222936",
              },
              show: true,
            },

            axisLabel: {
              color: dark.font_color,
              fontSize: 10,
              fontFamily: "Poppins",
              // formatter: function (value) {
              //   value = value.toLocaleString("pt-BR", {
              //     minimumFractionDigits: 0,
              //   });
              //   return value;
              // },
            },

            axisLine: {
              lineStyle: { color: dark.line },
            },
          },

          {
            scale: true,
            gridIndex: 1,
            splitNumber: 2,
            axisLabel: { show: false },
            axisLine: { show: false },
            axisTick: { show: false },
            splitLine: { show: false },
          },
        ],
        dataZoom: [
          {
            type: "inside",
            xAxisIndex: [0, 1],
            start: 0,
            end: 100,
            throttle: 10,
          },
          {
            show: true,
            xAxisIndex: [0, 1],
            type: "inside",
            top: "85%",
            start: 0,
            end: 100,
            throttle: 50,
          },
        ],
        series: [
          {
            type: "candlestick",
            itemStyle: {
              color: upColor,
              color0: downColor,
              borderColor: upBorderColor,
              borderColor0: downBorderColor,
            },
            // dimensions: ["dt", "o", "h", "l", "c", "t", "v"],
            // encode: {
            //   x: "dt",
            //   y: ["o", "h", "l", "c"],
            // },
            data: new_ohcl,

            markLine: {
              symbol: ["none", "none"],
              data: line,
            },

            markPoint: {
              label: {
                formatter: function (param) {
                  return param != null ? Math.round(param.value) + "" : "";
                },
              },
              data: point,
              tooltip: {
                formatter: function (param) {
                  return param.name + "<br>" + (param.data.coord || "");
                },
              },
            },
          },

          {
            name: "Volume",
            type: "bar",
            xAxisIndex: 1,
            yAxisIndex: 1,
            itemStyle: {
              color: "#057bbf",
            },
            // large: true,
            data: volume,
          },
        ],
      };

      this.data_chart = option;
    },
  },
};
</script>

<style>
.order-chart .echarts {
  width: 100%;
  height: 640px;
}
</style>
